<template>
    <v-app>
        <v-main>
            <v-container>
                <v-form ref="formRef" v-model="formValid">
                    <v-row dense>
                        <!-- No KTP -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.plg.id" label="No KTP" type="number" :rules="[rules.required]"
                                :error-messages="adaeror['plg.id']" :disabled="editmode" @blur="CariKTP"
                                @keydown="editmode ? '' : preventArrow($event)" outlined />
                            <v-alert type="success" v-if="form.KTPAda" dense text>
                                Data Pelanggan Ditemukan
                            </v-alert>
                        </v-col>

                        <!-- Nama -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.plg.nama" label="Nama" :rules="[rules.required]"
                                :error-messages="adaeror['plg.nama']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined />
                        </v-col>

                        <!-- Email -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.plg.email" label="Email" :rules="[rules.required, rules.email]"
                                :error-messages="adaeror['plg.email']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined />
                        </v-col>

                        <!-- HP -->
                        <v-col cols="12" md="6">
                            <v-text-field v-model="form.plg.hp" label="HP" :rules="[rules.required]"
                                :error-messages="adaeror['plg.hp']" :disabled="disable_plg || (editmode && !bolehedit)"
                                outlined />
                        </v-col>

                        <!-- Provinsi -->
                        <v-col cols="12" md="6">
                            <v-select v-model="form.plg.provinsi_id" :items="[{ text: 'Aceh', value: 1 }]"
                                label="Provinsi (sesuai KTP)" :rules="[rules.required]"
                                :error-messages="adaeror['plg.provinsi_id']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined
                                @change="loadKabupatenByProvinsi" />
                        </v-col>

                        <!-- Kabupaten -->
                        <v-col cols="12" md="6">
                            <v-select v-model="form.plg.kabupaten_id" :items="kabupatensTT"
                                label="Kabupaten (sesuai KTP)" item-text="value" item-value="id"
                                :rules="[rules.required]" :error-messages="adaeror['plg.kabupaten_id']"
                                :disabled="disable_plg || (editmode && !bolehedit)" @change="loadKecamatanByKabupaten"
                                outlined />
                        </v-col>

                        <!-- Kecamatan -->
                        <v-col cols="12" md="6">
                            <v-select v-model="form.plg.kecamatan_id" :items="kecamatanTT"
                                label="Kecamatan (sesuai KTP)" item-text="value" item-value="id"
                                :rules="[rules.required]" :error-messages="adaeror['plg.kecamatan_id']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined />
                        </v-col>

                        <!-- Alamat -->
                        <v-col cols="12" md="6">
                            <v-textarea no-resize rows="1" v-model="form.plg.alamat" label="Alamat (Detail Sesuai KTP)"
                                :rules="[rules.required]" :error-messages="adaeror['plg.alamat']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined />
                        </v-col>

                        <!-- Upload KTP -->
                        <v-col cols="12" md="6">
                            <v-file-input v-model="file" label="Upload KTP" accept="image/*" show-size
                                :rules="[rules.required]" :error-messages="adaeror['file']"
                                :disabled="disable_plg || (editmode && !bolehedit)" outlined @change="onUploadKTP" />
                        </v-col>

                        <!-- Tombol Simpan -->
                        <v-col cols="12" md="6" class="text-right">
                            <v-btn color="primary" @click="submitForm">Simpan</v-btn>
                        </v-col>
                        <!-- Preview Gambar -->
                        <v-col cols="12" md="6">
                            <v-img v-if="urlFotoKtpPreview" :src="urlFotoKtp" height="200" contain></v-img>
                            <v-img v-else-if="urlFotoKtp" :src="'./' + urlFotoKtp" height="200" contain></v-img>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
        </v-main>
    </v-app>
</template>


<script>
import { EventBus } from './../../event-bus'
export default {
    data() {
        return {
            form: {
                plg: {
                    id: '',
                    nama: '',
                    email: '',
                    hp: '',
                    provinsi_id: '',
                    kabupaten_id: '',
                    kecamatan_id: '',
                    alamat: '',
                },
                KTPAda: false,
            },
            adaeror: {},
            disable_plg: false,
            editmode: false,
            bolehedit: false,
            kabupatensTT: [],
            kecamatanTT: [],
            file: null,
            filename: '',
            urlFotoKtp: '',
            urlFotoKtpPreview: false,
            formValid: false,
            rules: {
                required: v => !!v || 'Harus diisi',
                email: v => /.+@.+\..+/.test(v) || 'Email tidak valid'
            },
        };
    },
    methods: {
        preventArrow(e) {
            if (["ArrowUp", "ArrowDown"].includes(e.key)) e.preventDefault();
        },
        CariKTP() {
            // fetch logic
        },
        loadKecamatanTT() {
            // fetch kecamatan
        },
        onUploadKTP(file) {
            if (file) {
                this.filename = file.name;
                this.urlFotoKtp = URL.createObjectURL(file);
                this.urlFotoKtpPreview = true;
            }
        },
        loadKabupatenByProvinsi() {
            const provId = this.form.plg.provinsi_id;
            if (!provId) return;

            // Misal pakai axios
            axios.get(`api/kabupaten/list?q=${provId}`)
                .then(res => {
                    this.kabupatensTT = res.data.data;
                    this.form.plg.kabupaten_id = '';
                    this.form.plg.kecamatan_id = '';
                    this.kecamatanTT = [];
                });
        },
        loadKecamatanByKabupaten() {
            const kabId = this.form.plg.kabupaten_id;
            if (!kabId) return;

            axios.get(`api/kecamatan/list?q=${kabId}`)
                .then(res => {
                    this.kecamatanTT = res.data.data;
                    this.form.plg.kecamatan_id = '';
                });
        },
        async submitForm() {
            const isValid = await this.$refs.formRef.validate();
            if (!isValid) {
                console.log("Form tidak valid");
                return;
            }

            try {
                const formData = new FormData();
                formData.append('id', this.form.plg.id);
                formData.append('nama', this.form.plg.nama);
                formData.append('email', this.form.plg.email);
                formData.append('hp', this.form.plg.hp);
                formData.append('provinsi_id', this.form.plg.provinsi_id);
                formData.append('kabupaten_id', this.form.plg.kabupaten_id);
                formData.append('kecamatan_id', this.form.plg.kecamatan_id);
                formData.append('alamat', this.form.plg.alamat);

                if (this.file) {
                    formData.append('file', this.file);
                }

                // Hit ke Laravel ControllerPelanggan@store
                const response = await axios.post('/api/pelanggan', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                console.log("Berhasil:", response.data);
                // Optional reset form
                this.$refs.formRef.reset();
                this.file = null;
                this.urlFotoKtp = '';
                this.urlFotoKtpPreview = false;
                this.adaeror = {};
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                EventBus.$emit('pelanggan:updated');
                EventBus.$emit('modal:close');
            } catch (error) {
                if (error.response && error.response.status === 422) {
                    this.adaeror = error.response.data.errors;
                    console.warn("Validasi gagal:", this.adaeror);
                } else {
                    console.error("Gagal simpan:", error);
                }
            }
        }
    },
};
</script>